import React from "react";
import { motion } from "framer-motion";
import { Phone, MessageCircle, Calendar } from "lucide-react";
import { PRIMARY_PHONE, WHATSAPP_URL } from "@/constants/content";
import { useBooking } from "@/contexts/BookingContext";

export default function FloatingActions() {
  const { open } = useBooking();
  return (
    <>
      {/* Desktop floating stack */}
      <div className="fixed bottom-5 right-5 z-40 hidden md:flex flex-col gap-3" data-testid="floating-actions">
        <motion.a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noreferrer"
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.4, type: "spring", stiffness: 260, damping: 20 }}
          className="pulse-ring-green group relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-xl hover:scale-110 transition-transform"
          aria-label="Chat on WhatsApp"
          data-testid="floating-whatsapp-btn"
        >
          <MessageCircle className="h-6 w-6" />
          <span className="absolute right-full mr-3 whitespace-nowrap rounded-md bg-slate-900 px-3 py-1.5 text-xs font-medium text-white opacity-0 group-hover:opacity-100 transition-opacity">
            Chat on WhatsApp
          </span>
        </motion.a>

        <motion.a
          href={`tel:${PRIMARY_PHONE}`}
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.55, type: "spring", stiffness: 260, damping: 20 }}
          className="pulse-ring group relative flex h-14 w-14 items-center justify-center rounded-full bg-[#EF4444] text-white shadow-xl hover:scale-110 transition-transform"
          aria-label="Emergency Call"
          data-testid="floating-emergency-btn"
        >
          <Phone className="h-6 w-6" />
          <span className="absolute right-full mr-3 whitespace-nowrap rounded-md bg-slate-900 px-3 py-1.5 text-xs font-medium text-white opacity-0 group-hover:opacity-100 transition-opacity">
            Emergency Call
          </span>
        </motion.a>

        <motion.button
          onClick={() => open()}
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.7, type: "spring", stiffness: 260, damping: 20 }}
          className="group relative flex h-14 w-14 items-center justify-center rounded-full bg-[#0A84FF] text-white shadow-xl hover:scale-110 transition-transform"
          aria-label="Book Appointment"
          data-testid="floating-book-btn"
        >
          <Calendar className="h-6 w-6" />
          <span className="absolute right-full mr-3 whitespace-nowrap rounded-md bg-slate-900 px-3 py-1.5 text-xs font-medium text-white opacity-0 group-hover:opacity-100 transition-opacity">
            Book Appointment
          </span>
        </motion.button>
      </div>

      {/* Mobile sticky bottom CTA bar */}
      <div className="fixed bottom-0 inset-x-0 z-40 md:hidden safe-bottom" data-testid="mobile-cta-bar">
        <div className="glass border-t border-slate-200/70 grid grid-cols-3 gap-1 p-2 shadow-[0_-8px_24px_rgba(15,23,42,0.08)]">
          <a href={`tel:${PRIMARY_PHONE}`} className="flex flex-col items-center gap-0.5 py-2 rounded-lg bg-[#EF4444] text-white text-[11px] font-semibold" data-testid="mobile-call-btn">
            <Phone className="h-4 w-4" /> Call
          </a>
          <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" className="flex flex-col items-center gap-0.5 py-2 rounded-lg bg-[#25D366] text-white text-[11px] font-semibold" data-testid="mobile-whatsapp-btn">
            <MessageCircle className="h-4 w-4" /> WhatsApp
          </a>
          <button onClick={() => open()} className="flex flex-col items-center gap-0.5 py-2 rounded-lg bg-[#0A84FF] text-white text-[11px] font-semibold" data-testid="mobile-book-btn">
            <Calendar className="h-4 w-4" /> Book
          </button>
        </div>
      </div>
    </>
  );
}
